export enum ReportStatus {
  EXPORT_STATUS_COMPLETE = 'EXPORT_STATUS_COMPLETE',
  COMPLETE = 'COMPLETE',
  EXPORT_STATUS_PENDING = 'EXPORT_STATUS_PENDING',
  EXPORT_STATUS_ERROR = 'EXPORT_STATUS_ERROR',
}

export interface ReportParameters {
  corpIds: string[];
  locationIds?: string[];
  employeeEmails?: string;
}

export interface Report {
  exportId: string;
  status: ReportStatus;
  reportDisplayName: string;
  requestedAt: string;
  downloadable: boolean;
  statusMessage?: string;
  exportName: string;
  startDate: string;
  endDate: string;
  reportParameters: ReportParameters;
}
